import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

export const setTenantSourceState = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.actions.rpc.demoTools.SetTenantSourceStateAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/demoTools/setTenantSourceState', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/demoTools/setTenantSourceState', {
      category: 'rpc',
      type: 'rpc/demoTools/setTenantSourceState',
      payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Set tenantSource error failed',
      error,
    })
  }
})
